<template>
  <div>
    this is a placeholder for the user settings page
  </div>
</template>
